(function() {
  // Get gift wrap configuration from the DOM
  const getGiftWrapConfig = () => {
    const giftWrapEl = document.querySelector('[data-gift-wrap]');
    if (!giftWrapEl) return { variantId: null, productId: null };
    
    return {
      variantId: Number(giftWrapEl.dataset.giftWrapVariantId),
      productId: Number(giftWrapEl.dataset.giftWrapProductId)
    };
  };

  // Utility
  const fetchJSON = (url, options={}) =>
    fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, options))
      .then(r => r.json());

  const getCart = () => fetchJSON('/cart.js');

  const refreshCartSections = async () => {
    const sections = getSectionsToUpdate();
    if (!sections.length) return;

    const sectionsParam = sections.join(',');

    const [cart, sectionsHTML] = await Promise.all([
      getCart(),
      fetch(`${window.location.pathname}?sections=${sectionsParam}`).then(r => r.json()),
    ]);

    const parsedState = {
      ...cart,
      sections: sectionsHTML,
    };

    if (window.FoxThemeEvents) {
      window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
    }
  };

  // Add gift wrap with message - quantity always 1
  const addGiftWrap = async (message) => {
    const { variantId } = getGiftWrapConfig();
    if (!variantId) throw new Error('Gift wrap variant ID not found');
    
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { 
            _gift_wrap: 'true',
            'Message': message || ''
          }
        }]
      })
    });
  };

  // Remove gift wrap using cart/update.js with sections
  const removeGiftWrap = async () => {
    const { variantId } = getGiftWrapConfig();
    if (!variantId) throw new Error('Gift wrap variant ID not found');
    
    const sections = getSectionsToUpdate();
    
    const body = JSON.stringify({
      updates: { [variantId]: 0 },
      sections: sections,
      sections_url: window.location.pathname
    });

    return fetch(window.FoxThemeSettings.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    }).then(r => r.json());
  };

  // Update existing gift wrap message using cart/change.js with sections
  const updateGiftMessage = async (message) => {
    const { variantId } = getGiftWrapConfig();
    if (!variantId) throw new Error('Gift wrap variant ID not found');
    
    const cart = await getCart();
    const giftWrapItem = cart.items.find(item => item.id === variantId);
    
    if (!giftWrapItem) return null;
    
    const sections = getSectionsToUpdate();
    
    const body = JSON.stringify({
      id: giftWrapItem.key,
      quantity: 1,
      properties: { 
        ...giftWrapItem.properties,
        'Message': message || '' 
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    return fetch(window.FoxThemeSettings.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    }).then(r => r.json());
  };

  // Get sections to update (matching the theme's pattern)
  const getSectionsToUpdate = () => {
    let sectionsToBundle = [];
    
    // Dispatch event to collect other sections that need updating
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const cartDrawer = document.querySelector("cart-drawer");
    const mainCart = document.querySelector("cart-items");

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionsToBundle = [
        ...sectionsToBundle,
        ...cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
    }

    if (mainCart && typeof mainCart.getSectionsToRender === 'function') {
      sectionsToBundle = [
        ...sectionsToBundle,
        ...mainCart.getSectionsToRender().map((section) => section.section),
      ];
    }

    return sectionsToBundle;
  };

  // Ensure gift wrap quantity is always 1
  const enforceGiftWrapQuantity = async () => {
    const { variantId } = getGiftWrapConfig();
    if (!variantId) return null;
    
    const cart = await getCart();
    const giftWrapItem = cart.items.find(item => item.id === variantId);
    
    if (giftWrapItem && giftWrapItem.quantity > 1) {
      const sections = getSectionsToUpdate();
      
      const body = JSON.stringify({
        id: giftWrapItem.key,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });

      const response = await fetch(window.FoxThemeSettings.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      }).then(r => r.json());
      
      return response; // Return the response to emit the event
    }
    return null;
  };

  const hasGiftWrap = async () => {
    const { variantId } = getGiftWrapConfig();
    if (!variantId) return false;
    
    const cart = await getCart();
    return cart.items.find(item => item.id === variantId);
  };

  // Get current gift message
  const getCurrentMessage = async () => {
    const { variantId } = getGiftWrapConfig();
    if (!variantId) return '';
    
    const cart = await getCart();
    const giftWrapItem = cart.items.find(item => item.id === variantId);
    return giftWrapItem?.properties?.Message || '';
  };

  // UI Sync - optimized to reduce API calls
  const syncUI = async () => {
    const wrapEls = document.querySelectorAll('[data-gift-wrap]');
    if (!wrapEls.length) return;

    const { variantId } = getGiftWrapConfig();
    
    // Single API call to get cart
    const cart = await getCart();
    
    // Find gift wrap item in one pass
    const giftWrapItem = cart.items.find(item => item.id === variantId);
    const hasWrap = !!giftWrapItem;
    const currentMessage = giftWrapItem?.properties?.Message || '';
    
    // Calculate if cart is empty (excluding gift wrap item itself)
    const nonGiftWrapItems = cart.items.filter(item => item.id !== variantId);
    const isCartEmpty = nonGiftWrapItems.length === 0;

    // If cart is empty but gift wrap exists, remove the gift wrap
    if (isCartEmpty && hasWrap) {
      console.log('Cart only contains gift wrap - removing it');
      try {
        const parsedState = await removeGiftWrap();
        
        

        // Emit the cart update event
        if (parsedState && window.FoxThemeEvents) {
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
        }
      } catch (error) {
        console.error('Error removing orphaned gift wrap:', error);
      }
    //   return; // Exit early since we're removing the gift wrap
    }

    // 🔹 NEW: if cart is empty, aggressively clean up any leftover gift wrap item DOM
    if (isCartEmpty) {
      const { productId } = getGiftWrapConfig();
      if (productId) {
        document
          .querySelectorAll(`[data-cart-item-product-id="${productId}"]`)
          .forEach(el => el.remove());
      }
    }

    for (const root of wrapEls) {
      const button = root.querySelector('[data-gift-wrap-button]');
      const removeBtn = root.querySelector('[data-gift-wrap-remove]');
      const textarea = root.querySelector('[data-gift-wrap-message]');
      const status = root.querySelector('[data-gift-wrap-status]');

      if (!button || !textarea) continue;

      // Hide/show gift wrap form based on cart state
      if (isCartEmpty) {
        const giftWrapItemAgain = cart.items.find(item => item.id === variantId);
        const hasWrapAgain = !!giftWrapItemAgain;

        root.classList.add('is-hidden');
        continue; // skip the rest of the UI updates for this root
      } else {
        root.classList.remove('is-hidden');
      }

      // Update UI based on gift wrap status
      if (hasWrap) {
        button.textContent = 'Update Message';
        button.disabled = false;
        textarea.value = currentMessage;
        if (removeBtn) removeBtn.style.display = 'inline-block';
        if (status) {
          status.textContent = 'Gift wrap added to cart';
          status.className = 'gift-wrap-status success';
        }
      } else {
        button.textContent = 'Add';
        button.disabled = false;
        textarea.value = '';
        if (removeBtn) removeBtn.style.display = 'none';
        if (status) {
          status.textContent = '';
          status.className = 'gift-wrap-status';
        }
      }
    }

  };

  // Handle button clicks
  document.addEventListener('click', async (e) => {
    // Add/Update gift wrap button
    if (e.target.matches('[data-gift-wrap-button]')) {
      e.preventDefault();
      const root = e.target.closest('[data-gift-wrap]');
      const textarea = root.querySelector('[data-gift-wrap-message]');
      const button = e.target;
      const status = root.querySelector('[data-gift-wrap-status]');
      
      if (!textarea) return;

      const message = textarea.value.trim();
      
      // Disable button and show loading
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      if (status) {
        status.textContent = 'Processing...';
        status.className = 'gift-wrap-status loading';
      }

      try {
        const hasWrap = await hasGiftWrap();
        let parsedState;
        
        if (hasWrap) {
          parsedState = await updateGiftMessage(message);
        } else {
          // For add, we need to do two calls: add then get sections
          await addGiftWrap(message);
          // Now fetch with sections to get the updated HTML
          const sections = getSectionsToUpdate();
          const cart = await getCart();
          
          // Fetch sections separately
          const sectionsParam = sections.join(',');
          const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sectionsParam}`);
          const sectionsData = await sectionsResponse.json();
          
          parsedState = {
            ...cart,
            sections: sectionsData
          };
        }

        // Ensure only 1 gift wrap
        const enforcedState = await enforceGiftWrapQuantity();
        if (enforcedState) {
          parsedState = enforcedState;
        }
        
        // Emit the cart update event with parsed state (this updates the UI)
        if (parsedState && window.FoxThemeEvents) {
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
        }
        
        // Update UI
        await syncUI();
        
      } catch (error) {
        console.error('Gift wrap error:', error);
        button.disabled = false;
        button.textContent = originalText;
        if (status) {
          status.textContent = 'Error occurred. Please try again.';
          status.className = 'gift-wrap-status error';
        }
      }
    }

    // Remove gift wrap button
    if (e.target.matches('[data-gift-wrap-remove]')) {
      e.preventDefault();
      const button = e.target;
      const root = e.target.closest('[data-gift-wrap]');
      const status = root.querySelector('[data-gift-wrap-status]');
      
      button.disabled = true;
      button.textContent = 'Removing...';

      try {
        const parsedState = await removeGiftWrap();
        
        // Emit the cart update event with parsed state (this updates the UI)
        if (parsedState && window.FoxThemeEvents) {
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
        }
        
        await syncUI();
      } catch (error) {
        console.error('Remove gift wrap error:', error);
        button.disabled = false;
        button.textContent = 'Remove';
        if (status) {
          status.textContent = 'Error removing gift wrap.';
          status.className = 'gift-wrap-status error';
        }
      }
    }
  });

  // Check and clear orphaned gift wrap on page load
  const clearOrphanedGiftWrap = async () => {
    try {
      const cart = await getCart();
      const { variantId } = getGiftWrapConfig();
      
      if (!variantId) return;
      
      // Check if cart only contains gift wrap
      const nonGiftWrapItems = cart.items.filter(item => item.id !== variantId);
      const giftWrapItem = cart.items.find(item => item.id === variantId);
      
      if (giftWrapItem && nonGiftWrapItems.length === 0) {
        console.log('Orphaned gift wrap detected on page load - removing it');
        const parsedState = await removeGiftWrap();
        
        // Emit the cart update event
        if (parsedState && window.FoxThemeEvents) {
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
        }
      }
    } catch (error) {
      console.error('Error checking for orphaned gift wrap:', error);
    }
  };

  // Initial sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', async () => {
      await clearOrphanedGiftWrap();
      await syncUI();
    });
  } else {
    clearOrphanedGiftWrap().then(() => syncUI());
  }
  
  
  // Listen for cart updates and enforce gift wrap quantity + sync UI
  if (window.FoxThemeEvents && window.FoxThemeEvents.subscribe) {
    window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, async (parsedState) => {
      console.log('PUB_SUB_EVENTS.cartUpdate fired', parsedState);
      
      // Check and enforce quantity whenever cart updates
      const enforcedState = await enforceGiftWrapQuantity();
      
      // If we had to enforce (quantity was > 1), emit another update
      if (enforcedState && window.FoxThemeEvents) {
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, enforcedState);
      }
      
      // Always sync UI to update visibility and state
      await syncUI();
    });
  }
  
  // Legacy event support
  document.addEventListener('cart:updated', async () => {
    console.log('cart:updated event fired');
    const enforcedState = await enforceGiftWrapQuantity();
    if (enforcedState && window.FoxThemeEvents) {
      window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, enforcedState);
    }
    await syncUI();
  });


  // Watch for DOM changes in cart elements
  const observeCartChanges = () => {
    const cartDrawer = document.querySelector('cart-drawer, .cart-drawer, #cart-drawer');
    const mainCart = document.querySelector('cart-items, .cart-items, #cart-items');
    
    const observer = new MutationObserver(async (mutations) => {
      // Check if any cart item was added or removed
      const hasCartItemChange = mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('f-cart-item') || 
            node.querySelector?.('.f-cart-item') ||
            node.classList?.contains('cart-item') ||
            node.querySelector?.('.cart-item')
          )
        ) || Array.from(mutation.removedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('f-cart-item') || 
            node.classList?.contains('cart-item')
          )
        );
      });
      
      if (hasCartItemChange) {
        console.log('Cart DOM changed - syncing UI');
        await syncUI();
        
        // Also check for orphaned gift wrap after a short delay
        setTimeout(async () => {
          await clearOrphanedGiftWrap();
        }, 500);
      }
    });
    
    const config = { childList: true, subtree: true };
    
    if (cartDrawer) {
      observer.observe(cartDrawer, config);
      console.log('Observing cart drawer for changes');
    }
    if (mainCart) {
      observer.observe(mainCart, config);
      console.log('Observing main cart for changes');
    }
  };
  
  // Start observing after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartChanges);
  } else {
    observeCartChanges();
  }
  
  // Also poll periodically as a backup (every 3 seconds, less aggressive)
  let lastKnownCartState = null;
  
  setInterval(async () => {
    const wrapEls = document.querySelectorAll('[data-gift-wrap]');
    if (wrapEls.length > 0) {
      try {
        const cart = await getCart();
        const { variantId } = getGiftWrapConfig();
        const nonGiftWrapItems = cart.items.filter(item => item.id !== variantId);
        const isCartEmpty = nonGiftWrapItems.length === 0;
        
        // Create a simple state signature
        const currentState = `${cart.item_count}-${isCartEmpty}`;
        
        // Only sync if state actually changed
        if (lastKnownCartState !== currentState) {
          console.log('Periodic check: Cart state changed, syncing UI');
          lastKnownCartState = currentState;
          await syncUI();
        }
      } catch (error) {
        // Silently fail on periodic checks
      }
    }
  }, 3000);
})();